import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { breadcrumb, breadcrumbResolve, breadcrumbResolved } from 'rise-ui/services/breadcrumb.js';
import { pageNotFoundModel } from 'rise-ui/services/page-not-found-model.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';
import { buildJsonLd, locationDataset } from 'rise-ui/utils/data';

@pageNotFoundModel({
  name: 'location',
  class: 'qa-error-location-not-found',
})
@scrollRoot
export default class LocationDetailRoute extends Route {
  @service dataset;
  @service keywords;
  @service store;

  setHeadTags(model) {
    const { location } = model;
    const keywords = new Set();
    location.catalogRecords?.forEach(record =>
      record.themes?.forEach(tag => keywords.add(tag))
    );
    location.tags?.forEach(tag => keywords.add(tag));
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: location.description,
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(
            false,
            Array.from(keywords),
          ),
        },
      },
      {
        type: 'script',
        attrs: {
          type: 'application/ld+json',
        },
        content: buildJsonLd(locationDataset(location, this.dataset.urlFn)),
      },
    ];
  }

  @breadcrumb crumb = 'Location';

  model({ location_id }) {
    const location = this.store.findRecord('location', location_id, {
      include: 'catalogRecords,catalogRecords.catalogItems,modelRuns',
      backgroundReload: true,
    });
    return hash({
      location,
      catalogRecords: location.then(({ catalogRecords }) => catalogRecords),
      relatedLocations: location.then(({ relatedLocations }) => relatedLocations)
        .catch(() => {}),
    });
  }

  @breadcrumbResolve crumbResolve(model) {
    return model?.location;
  }
  @breadcrumbResolved modelCrumb(model) {
    return model && [ 'Location', model.location.get('name') ];
  }
}
